import { useMutation } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import { resendContractBiometry } from '~/services-v2/contract-formalization-api/contract-formalization-api'

export default function useContractResend(projectId: Ref<string>) {
  const mutationFn = async () => {
    return resendContractBiometry(projectId.value)
  }

  return useMutation({
    mutationFn,
    mutationKey: queryKeys.CONTRACT_BIOMETRY.RESEND_CONTRACT,
    retry: 3,
    retryDelay: 1000,
  })
}
